export const ClientIdPrefix = 'clientid:';
export const LocalEventPrefix = 'localevent:';
export const ConversationIdPrefix = 'conversationid:';
export const ItemIdPrefix = 'itemid:';
export const ParentFolderIdPrefix = 'parentfolderid:';
export const DisplayNamePrefix = 'displayname:';
export const FavoriteTypePrefix = 'favoritetype:';
export const AccountPrefix = 'account:';
export const InlineImageClientIdPrefix = 'blob:';
